if (!customElements.get("more-from-brand")) {
  let scheduleProcessing2 = function() {
    if (processScheduled) return;
    processScheduled = true;
    queueMicrotask(() => {
      processScheduled = false;
      processAllMoreFromBrandHosts2();
    });
  }, groupHostsKey2 = function(host) {
    return `${host.dataset.productId}|${host.dataset.url}`;
  }, finalizeHost2 = function(host, clonedSlides) {
    const sectionEl = host.querySelector(".section");
    if (sectionEl) sectionEl.classList.remove("more-from-brand--loading");
    const productSlider = host.querySelector("product-slider");
    if (productSlider) {
      productSlider.dataset.totalItems = clonedSlides.length.toString();
      if (typeof productSlider.init === "function") productSlider.init();
    }
    host.dispatchEvent(new CustomEvent("more-from-brand:loaded"));
    host.dataset.mfbHydrated = "true";
  }, uniqueSlidesFromDoc2 = function(doc, productId) {
    const productCards = doc.querySelector("[data-product-cards]");
    if (!productCards || !productCards.children.length) return [];
    const slides = Array.from(productCards.children);
    const uniqueSlides = [];
    const seen = /* @__PURE__ */ new Set();
    if (productId) seen.add(productId);
    slides.forEach((slide) => {
      const sid = parseInt(slide.dataset.productId, 10);
      if (!sid || seen.has(sid)) return;
      seen.add(sid);
      uniqueSlides.push(slide);
    });
    return uniqueSlides;
  }, applySliceToHost2 = function(host, slice, productId) {
    var _a;
    const placeholder = host.querySelector("[data-products-placeholder]");
    if (!placeholder) return;
    const filtered = slice.filter((slide) => {
      const sid = parseInt(slide.dataset.productId, 10);
      return !sid || sid !== productId;
    });
    if (filtered.length === 0) {
      (_a = host.closest(".shopify-section")) == null ? void 0 : _a.remove();
      return;
    }
    filtered.forEach((slide) => placeholder.appendChild(slide.cloneNode(true)));
    finalizeHost2(host, filtered);
  }, loadGroup2 = function(hosts) {
    if (!hosts.length) return Promise.resolve();
    const productId = parseInt(hosts[0].dataset.productId, 10);
    const url = hosts[0].dataset.url;
    const limits = hosts.map((h) => parseInt(h.dataset.limit, 10) || 8);
    const combinedLimit = Math.min(
      250,
      limits.reduce((a, b) => a + b, 0) + 4
    );
    if (hosts.length === 1) {
      const host = hosts[0];
      const limit = limits[0];
      return fetch(`${url}&limit=${limit}`).then((response) => response.text()).then((html) => {
        var _a;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const uniqueSlides = uniqueSlidesFromDoc2(doc, productId);
        if (uniqueSlides.length === 0) {
          (_a = host.closest(".shopify-section")) == null ? void 0 : _a.remove();
          return;
        }
        applySliceToHost2(host, uniqueSlides.slice(0, limit), productId);
      }).catch((e) => {
        var _a;
        console.error("More from brand:", e);
        (_a = host.closest(".shopify-section")) == null ? void 0 : _a.remove();
      });
    }
    return fetch(`${url}&limit=${combinedLimit}`).then((response) => response.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const uniqueSlides = uniqueSlidesFromDoc2(doc, productId);
      if (uniqueSlides.length === 0) {
        hosts.forEach((h) => {
          var _a;
          return (_a = h.closest(".shopify-section")) == null ? void 0 : _a.remove();
        });
        return;
      }
      let offset = 0;
      hosts.forEach((host, i) => {
        const take = limits[i];
        const slice = uniqueSlides.slice(offset, offset + take);
        offset += take;
        applySliceToHost2(host, slice, productId);
      });
    }).catch((e) => {
      console.error("More from brand:", e);
      hosts.forEach((h) => {
        var _a;
        return (_a = h.closest(".shopify-section")) == null ? void 0 : _a.remove();
      });
    });
  }, processAllMoreFromBrandHosts2 = function() {
    const hosts = getHostsByDocumentOrder();
    if (!hosts.length) return;
    const byKey = /* @__PURE__ */ new Map();
    hosts.forEach((h) => {
      if (h.dataset.mfbHydrated === "true" || h.dataset.mfbInflight === "true") return;
      const k = groupHostsKey2(h);
      if (!byKey.has(k)) byKey.set(k, []);
      byKey.get(k).push(h);
    });
    byKey.forEach((groupHosts) => {
      if (!groupHosts.length) return;
      groupHosts.forEach((h) => {
        h.dataset.mfbInflight = "true";
      });
      loadGroup2(groupHosts).finally(() => {
        groupHosts.forEach((h) => {
          delete h.dataset.mfbInflight;
        });
      });
    });
  };
  var scheduleProcessing = scheduleProcessing2, groupHostsKey = groupHostsKey2, finalizeHost = finalizeHost2, uniqueSlidesFromDoc = uniqueSlidesFromDoc2, applySliceToHost = applySliceToHost2, loadGroup = loadGroup2, processAllMoreFromBrandHosts = processAllMoreFromBrandHosts2;
  let processScheduled = false;
  const getHostsByDocumentOrder = () => [...document.querySelectorAll("more-from-brand")].filter((h) => (h.dataset || {}).url);
  let idleRequestScheduled = false;
  class MoreFromBrand extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.dataset.url) return;
      if ("requestIdleCallback" in window) {
        if (idleRequestScheduled) return;
        idleRequestScheduled = true;
        requestIdleCallback(
          () => {
            idleRequestScheduled = false;
            scheduleProcessing2();
          },
          { timeout: 1500 }
        );
      } else {
        scheduleProcessing2();
      }
    }
  }
  customElements.define("more-from-brand", MoreFromBrand);
}
